import { render, staticRenderFns } from "./AsessmentPage.vue?vue&type=template&id=69fde3c4&"
import script from "./AsessmentPage.vue?vue&type=script&lang=js&"
export * from "./AsessmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports